import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Layout, Menu } from "components/common";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { getMenus } from "common/menu";
import { getSudo, getToken } from "utils/auth";
import LogoIcon from "assets/icons/nueva/icons/Nueva-icon.svg";
import { ReactComponent as SmallLogoIcon } from "assets/icons/new-sidebar/my-daily-mbl-logo.svg";
import { ReactComponent as ArrowDownIcon } from "assets/icons/sidebar/Arrow-Down2.svg";
import { ReactComponent as ArrowRightIcon } from "assets/icons/sidebar/Arrow-Right.svg";
import { callGetApi, callGetApiWithAuth } from "utils/api";

const { SubMenu } = Menu;
const { Sider } = Layout;

export default function Sidebar({ width }) {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const sudoName = getSudo();
  const token = getToken();
  const myUser = useSelector((state) => state.auth.user);
  const isCollapse = useSelector((state) => state.ui.isCollapse);
  const isHoverSidebar = useSelector((state) => state.ui.isHoverSidebar);
  const [menus, setMenus] = useState([]);
  const [travelUrl, setTravelUrl] = useState("");

  const customExpandIcon = ({ isOpen }) => {
    return (
      <div style={{ paddingRight: "30px" }}>
        {isOpen ? <ArrowDownIcon /> : <ArrowRightIcon />}
      </div>
    );
  };

  const onMenuClick = (e) => {
    console.log(e);
    if (e.key === "/shop" && token) {
      window.open(
        `${process.env.REACT_APP_CORP_URL}/login?auto-token-login&pathName=shop&token=${token}`,
        "_blank"
      );
    } else if (e.key === "/akashx" && token) {
      window.open(
        `${process.env.REACT_APP_AKASHX_URL}/login?auto-token-login&token=${token}`,
        "_blank"
      );
    } else if (e.key === "/ticket/buy_ticket" && token) {
      window.open(
        `${process.env.REACT_APP_CORP_URL}/login?auto-token-login&token=${token}&pathName=events`,
        "_blank"
      );
    } else if (e.key === "/blog" && token) {
      window.open(
        `${process.env.REACT_APP_CORP_URL}/login?auto-token-login&pathName=news&token=${token}`,
        "_blank"
      );
    } else if (e.key === "/event" && token) {
      window.open(
        `${process.env.REACT_APP_CORP_URL}/login?auto-token-login&pathName=events&token=${token}`,
        "_blank"
      );
    } else if (e.key === "/telegram_channel") {
      window.open(`https://t.me/NuevaNews`, "_blank");
    } else if (e.key === "/lead_traffic") {
      window.open(`https://capturepagetraffic.com`, "_blank");
      // } else if (e.key === "/ican_institue") {
      //   window.open(`https://icaninstitute.mykajabi.com/login`, '_blank')
      // } else if (e.key === "/ican_start") {
      //   window.open(`https://icaninstitute.mykajabi.com/login`, '_blank')
      // } else if (e.key === "/ican_mindset") {
      //   window.open(`https://icaninstitute.mykajabi.com/login`, '_blank')
    } else if (e.key === "/travel/nv_travel" && token) {
      if (myUser.has_travel) {
        window.open(travelUrl, "_blank");
      } else {
        window.open(
          `${process.env.REACT_APP_CORP_URL}/login?auto-token-login&pathName=buy-nueva-travel&token=${token}`,
          "_blank"
        );
      }
    }  else if (e.key === "/travel/ad_sso" && token) {

      if (myUser.has_travel) {
        const newWindow = window.open("", "_blank");
        // Call API
        callGetApiWithAuth("hlt/amt_login", (res) => {
          if (newWindow) {
            newWindow.location.href = `https://nuevadeals.com/director?cvt=${myUser.hlt_setting.amt_account}`;
          }
        });
      } else {
        window.open(
          `${process.env.REACT_APP_CORP_URL}/login?auto-token-login&pathName=buy-nueva-travel&token=${token}`,
          "_blank"
        );
      }
     
    }  else if (e.key === "/shop_nueva" && token) {
      window.open(
        `${process.env.REACT_APP_CORP_URL}/login?auto-token-login&token=${token}&pathName=shop`,
        "_blank"
      );
    } else if (e.key === "/shop_bodynbeauty" && token) {
      window.open(
        `https://bodynbeauty.com/login?auto-token-login&token=${token}&pathName=shop`,
        "_blank"
      );
    } else {
      history.push(e.key);
    }
  };

  const useWindowDimensions = () => {
    const hasWindow = typeof window !== "undefined";

    function getWindowDimensions() {
      const height = hasWindow ? window.innerHeight : null;
      const width_ = hasWindow ? window.innerWidth : null;
      return {
        height,
        width_,
      };
    }

    const [windowDimensions, setWindowDimensions] = useState(
      getWindowDimensions()
    );

    useEffect(() => {
      if (hasWindow) {
        function handleResize() {
          setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
      }
    }, [hasWindow]);

    return windowDimensions;
  };

  const { height, width_ } = useWindowDimensions();

  useEffect(() => {
    if (width_ < 900) {
      dispatch({
        type: "ui.SET_COLLAPSE",
        payload: {
          isCollapse: false,
        },
      });
    }
  }, [width_]);

  const onGetTravelUrl = (res) => {
    setTravelUrl(res.data);
  };

  useEffect(() => {
    if (myUser) {
      setMenus(getMenus(myUser));
      callGetApiWithAuth(
        "my_account/subscription/get_travel_url",
        onGetTravelUrl
      );
    }
  }, [myUser]);

  return (
    <SiderWrapper
      onMouseEnter={() => {
        dispatch({
          type: "ui.SET_HOVER_SIDEBAR",
          payload: {
            isHoverSidebar: true,
          },
        });
      }}
      onMouseLeave={() => {
        dispatch({
          type: "ui.SET_HOVER_SIDEBAR",
          payload: {
            isHoverSidebar: false,
          },
        });
      }}
      className={
        isCollapse && !isHoverSidebar
          ? "sidebar-wrapper sidebar-collapsed"
          : "sidebar-wrapper"
      }
      style={{ width: width || "300px" }}
    >
      <Sider
        trigger={null}
        collapsible
        collapsed={isHoverSidebar ? false : isCollapse}
      >
        {isCollapse && !isHoverSidebar ? (
          <div className="logo small-logo">
            <SmallLogoIcon />
          </div>
        ) : (
          <>
            <div className="logo">
              <img src={LogoIcon} />
            </div>
            <hr className="logo-hr" />
          </>
        )}
        <div className="menu-container sidebar-light-menu">
          <Menu
            theme="dark"
            mode="inline"
            expandIcon={customExpandIcon}
            defaultSelectedKeys={[history?.location?.pathname]}
            selectedKeys={[history?.location?.pathname]}
            onClick={onMenuClick}
            triggerSubMenuAction={"click"}
            style={{
              height: height - 120,
            }}
          >
            {menus.map((menu) =>
              menu.submenus && menu.submenus.length > 0 ? (
                <SubMenu
                  icon={menu.icon}
                  key={menu.route}
                  title={t(menu.label)}
                >
                  {menu.submenus.map((submenu) => (
                    <Menu.Item key={submenu.route}>
                      {t(submenu.label)}
                    </Menu.Item>
                  ))}
                </SubMenu>
              ) : (
                <Menu.Item
                  key={menu.route}
                  icon={
                    history?.location?.pathname == menu.route &&
                      menu.selectedIcon
                      ? menu.selectedIcon
                      : menu.icon
                  }
                >
                  {t(menu.label)}
                </Menu.Item>
              )
            )}
          </Menu>
        </div>
      </Sider>
    </SiderWrapper>
  );
}

const SiderWrapper = styled.div`
  position: fixed;
  height: 100%;
  background: white;
  width: 300px;
  z-index: 2 !important;
  border-right: 1px dashed rgba(145, 158, 171, 0.24);
  transition: width 0.7s;
  transition-timing-function: ease-in-out;
  cursor: pointer;

  .ant-layout-sider {
    font-family: "Roboto", sans-serif;
    background: #1e1b1d;
    width: 100% !important;
    max-width: 100% !important;
    height: 100%;
    padding: 0px 5px 0px 20px;
    .ant-menu.ant-menu-dark,
    .ant-menu-dark .ant-menu-sub,
    .ant-menu.ant-menu-dark .ant-menu-sub {
      background: transparent;
    }
    .ant-menu-item {
      padding: 25px 0px 25px 12px !important;
      margin: 0px;
      color: #f9f6f0;
      width: calc(100% - 7px);
    }
    .ant-menu-item-icon {
      width: 23px;
    }
    .ant-menu-item-selected {
      .ant-menu-item-icon {
        rect {
          fill: #0abab5;
          stroke: #0abab5;
        }
        path:nth-child(even) {
          /* fill: #0abab5; */
          /* stroke: #0abab5; */
        }
        path:nth-child(odd) {
          /* fill: #0abab5; */
          /* stroke: #0abab5; */
        }
      }
    }

    .ant-menu-submenu-expand-icon {
      width: 9px;
      transform: rotate(268deg);
      stroke: #f9f6f0;
      path {
        fill: #f9f6f0;
      }
    }
    .ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal)
      .ant-menu-item-selected {
      background-color: #00000077;
      border-radius: 8px;
      .ant-menu-title-content {
        color: #f9f6f0 !important;
        /* font-weight: 600; */
        margin-left: 17px;
      }
    }
    .ant-menu-sub .ant-menu-title-content {
      margin-left: 7px !important;
    }

    .ant-menu-root {
      overflow-y: auto;
      ::-webkit-scrollbar {
        width: 5px;
      }
      ::-webkit-scrollbar-track {
        border-radius: 10px;
        box-shadow: inset 0 0 5px transparent;
      }
      ::-webkit-scrollbar-thumb {
        background: #e4e4e485;
        border-radius: 10px;
      }
      ::-webkit-scrollbar-thumb:hover {
        background: #e4e4e485;
      }
    }
    .ant-menu-title-content {
      font-size: 14px;
      font-weight: 400;
      margin-left: 17px !important;
    }
    .ant-menu-sub {
      .ant-menu-title-content {
        margin-left: 7px !important;
      }
    }
    .ant-menu-submenu {
      color: #f9f6f0;
      .ant-menu-item {
        padding-left: 45px !important;
      }
      .ant-menu-submenu-title {
        color: #f9f6f0;
        padding: 23px 0px 23px 12px !important;
        margin: 0px;
        .ant-menu-submenu-expand-icon,
        .ant-menu-submenu-arrow {
          right: 25px;
        }
      }
    }
    .logo {
      display: flex;
      align-items: center;
      justify-content: start;
      width: 100%;
      margin: 35px 0px 24px 0px;
      svg {
        width: 150px;
      }
    }
    .logo-hr {
      height: 2px;
      width: 95%;
      color: #f3f3f3;
      margin-bottom: 25px;
    }
    .small-logo {
      margin: 14px 16px 20px -4px;
      svg {
        width: 40px !important;
      }
    }
  }
  .ant-layout-sider
    .ant-menu-submenu
    .ant-menu-submenu-title
    .ant-menu-submenu-expand-icon,
  .ant-layout-sider
    .ant-menu-submenu
    .ant-menu-submenu-title
    .ant-menu-submenu-arrow {
    top: 43% !important;
  }
`;
